<template>
  <div class="item">
    <div class="flex flex-between flex-middle item-head">
      <div class="item-head-title ellipsis">
        {{ data.abilityName }}
      </div>
      <div class="item-head-btn pointer" @click="toDetail">查看详情</div>
    </div>
    <div class="flex flex-middle flex-between item-content">
      <div class="flex-1">
        <div class="mb-12 item-content-info flex flex-middle">
          <el-image
            class="item-content-icon"
            :src="$oss('home/ability/detection_type.png')"
            fit="cover"
          ></el-image>
          <label>检测分类：</label>
          <span>
            {{ data.laboratoryAbilityTypeName }}
          </span>
        </div>
        <div class="mb-12 item-content-info flex flex-middle">
          <el-image
            class="item-content-icon"
            :src="$oss('home/ability/detection_base.png')"
            fit="cover"
          ></el-image>
          <label>检测依据：</label>
          <span class="ellipsis flex-1">{{ data.checkAccord }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    toDetail() {
      console.log(this.data);
      this.$router.push({
        name: "checkProjectDetail",
        query: {
          id: this.data.laboratoryAbilityId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.item {
  width: 392px;
  height: 143px;
  background: #ffffff;
  border-radius: 12px;
  padding: 0 16px;

  &-head {
    height: 57px;
    line-height: 57px;
    border-bottom: 1px solid #e6e6e6;

    color: #333333;
    &-title {
      width: 280px;
      font-size: 18px;
      font-weight: 500;
      color: #3d3d3d;
    }
    &-btn {
      width: 80px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: $theme-color;
      // background: $theme-color-light;
      border-radius: 4px 4px 4px 4px;
    }
  }
  &-content {
    padding: 12px 0;
    &-info {
      height: 30px;
      line-height: 30px;
    }
    &-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    label {
      width: 70px;
      color: #999999;
    }
    span {
      width: 270px;
    }
  }
}
</style>
